<template>
  <div id="app" class="military-tech-app">
    <!-- 顶部导航 -->
    <header class="military-header" :class="{ 'scrolled': isScrolled }">
      <div class="header-container">
        <!-- Logo区域 -->
        <div class="logo-section">
          <router-link to="/" class="logo-link" aria-label="返回首页">
            <el-image
              :src="require('@/assets/img/logo.jpg')"
              class="logo-image"
              :fit="'contain'"
              alt="公司Logo"
            />
          </router-link>
        </div>

        <!-- 桌面端导航 -->
        <nav class="desktop-nav">
          <el-menu
            :default-active="defaultActive"
            class="military-menu"
            mode="horizontal"
            :router="true"
            @select="handleSelect"
            background-color="transparent"
            text-color="#102542"
            active-text-color="#D4AF37"
            :ellipsis="false"
          >
            <el-menu-item index="/">{{ $t("Nav.sy") }}</el-menu-item>

            <el-sub-menu index="about" popper-class="military-submenu">
              <template #title>{{ $t("Nav.gywm") }}</template>
              <el-menu-item index="/about/profil">{{ $t("Nav.gywm_gsjj") }}</el-menu-item>
              <el-menu-item index="/about/honors">{{ $t("Nav.gywm_gsry") }}</el-menu-item>
              <el-menu-item index="/about/culture">{{ $t("Nav.gywm_qywh") }}</el-menu-item>
              <el-menu-item index="/about/responsibility">{{ $t("Nav.gywm_shzr") }}</el-menu-item>
            </el-sub-menu>

            <el-menu-item index="/services">{{ $t("Nav.cpyfw") }}</el-menu-item>

            <el-sub-menu index="technology" popper-class="military-submenu">
              <template #title>{{ $t("Nav.jsyf") }}</template>
              <el-menu-item index="/technology/team">{{ $t("Nav.jsyf_yfdw") }}</el-menu-item>
              <el-menu-item index="/technology/zizhirenzheng">{{ $t("Nav.cpyfw_zzrz") }}</el-menu-item>
              <el-menu-item index="/technology/patent">{{ $t("Nav.jsyf_yqhz") }}</el-menu-item>
              <el-menu-item index="/technology/cooperation">{{ $t("Nav.jsyf_yfcg") }}</el-menu-item>
              <el-menu-item index="/technology/achievements">{{ $t("Nav.jsyf_zlbz") }}</el-menu-item>
            </el-sub-menu>

            <el-menu-item index="/news">{{ $t("Nav.xwzx") }}</el-menu-item>

            <el-sub-menu index="party" v-if="lanNow == 'zh'" popper-class="military-submenu">
              <template #title>{{ $t("Nav.djyd") }}</template>
              <el-menu-item index="/part/study">{{ $t("Nav.djyd_xxyw") }}</el-menu-item>
              <el-menu-item index="/part/basic">{{ $t("Nav.djyd_jbgk") }}</el-menu-item>
              <el-menu-item index="/part/news">{{ $t("Nav.djyd_dqdt") }}</el-menu-item>
            </el-sub-menu>

            <el-menu-item index="/recruit">{{ $t("Nav.zpzx") }}</el-menu-item>
            <el-menu-item index="/contact">{{ $t("Nav.lxwm") }}</el-menu-item>
          </el-menu>

          <!-- 语言切换 -->
<!--          <button class="lang-switch" @click="changeLan"  style="width: 1px," >-->
<!--            <span class="lang-text">{{ lan }}</span>-->
<!--            <span class="lang-divider"></span>-->
<!--          </button>-->
        </nav>

        <!-- 移动端菜单按钮 -->
        <button
          class="mobile-menu-btn"
          @click="toggleMobileMenu"
          :aria-label="mobileMenuOpen ? '关闭菜单' : '打开菜单'"
          :aria-expanded="mobileMenuOpen"
          aria-controls="mobile-navigation"
        >
          <span class="menu-line" :class="{ 'active': mobileMenuOpen }"></span>
          <span class="menu-line" :class="{ 'active': mobileMenuOpen }"></span>
          <span class="menu-line" :class="{ 'active': mobileMenuOpen }"></span>
        </button>
      </div>
    </header>

    <!-- 移动端导航抽屉 -->
    <transition name="slide-drawer">
      <div
        v-if="mobileMenuOpen"
        id="mobile-navigation"
        class="mobile-drawer"
        @click.self="closeMobileMenu"
        role="dialog"
        aria-modal="true"
        aria-label="移动端导航菜单"
      >
        <nav class="mobile-nav">
          <div class="mobile-nav-header">
            <el-image :src="require('@/assets/img/logo.png')" class="mobile-logo" />
            <button class="close-btn" @click="closeMobileMenu">×</button>
          </div>

          <div class="mobile-menu-list">
            <router-link to="/" class="mobile-menu-item" @click="closeMobileMenu">
              {{ $t("Nav.sy") }}
            </router-link>

            <div class="mobile-submenu">
              <div class="mobile-submenu-title">{{ $t("Nav.gywm") }}</div>
              <router-link to="/about/profil" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.gywm_gsjj") }}
              </router-link>
              <router-link to="/about/culture" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.gywm_qywh") }}
              </router-link>
              <router-link to="/about/responsibility" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.gywm_shzr") }}
              </router-link>
            </div>

            <router-link to="/services" class="mobile-menu-item" @click="closeMobileMenu">
              {{ $t("Nav.cpyfw") }}
            </router-link>

            <div class="mobile-submenu">
              <div class="mobile-submenu-title">{{ $t("Nav.jsyf") }}</div>
              <router-link to="/technology/team" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.jsyf_yfdw") }}
              </router-link>
              <router-link to="/technology/patent" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.jsyf_yqhz") }}
              </router-link>
              <router-link to="/technology/cooperation" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.jsyf_yfcg") }}
              </router-link>
              <router-link to="/technology/achievements" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.jsyf_zlbz") }}
              </router-link>
            </div>

            <router-link to="/news" class="mobile-menu-item" @click="closeMobileMenu">
              {{ $t("Nav.xwzx") }}
            </router-link>

            <div v-if="lanNow == 'zh'" class="mobile-submenu">
              <div class="mobile-submenu-title">{{ $t("Nav.djyd") }}</div>
              <router-link to="/part/study" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.djyd_xxyw") }}
              </router-link>
              <router-link to="/part/basic" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.djyd_jbgk") }}
              </router-link>
              <router-link to="/part/news" class="mobile-submenu-item" @click="closeMobileMenu">
                {{ $t("Nav.djyd_dqdt") }}
              </router-link>
            </div>

            <router-link to="/recruit" class="mobile-menu-item" @click="closeMobileMenu">
              {{ $t("Nav.zpzx") }}
            </router-link>
            <router-link to="/contact" class="mobile-menu-item" @click="closeMobileMenu">
              {{ $t("Nav.lxwm") }}
            </router-link>
          </div>

          <!-- <button class="mobile-lang-switch" @click="changeLan">
            <span>切换语言 / Switch Language</span>
            <span class="lang-current">{{ lan }}</span>
          </button> -->
        </nav>
      </div>
    </transition>

    <!-- 主内容区域 -->
    <main class="main-content">
      <router-view />
    </main>

    <!-- 军工级页脚 -->
    <footer class="military-footer">
      <div class="footer-container">
        <div class="footer-grid">
          <!-- 公司信息 -->
          <div class="footer-section footer-brand">
<!--            <el-image -->
<!--              :src="require('@/assets/img/logo_bottom.png')" -->
<!--              class="footer-logo"-->
<!--              :fit="'contain'"-->
<!--            />-->
            <h3 class="footer-company">{{ $t("home.pName") }}</h3>
            <div class="footer-contact">
              <p><span class="contact-label">地址：石家庄高新区湘江道319号天山科技工业园孵化器D座01单元2302</span></p>
              <p><span class="contact-label">咨询热线：16603119506（李总）0311-88801394</span></p>
              <p><span class="contact-label">邮箱：zhongkeguoan@126.com</span></p>
              <p><span class="contact-label">邮编：050000</span></p>
            </div>
          </div>

          <!-- 快速链接 -->
          <div class="footer-section">
            <h4 class="footer-title">{{ $t("Nav.gywm") }}</h4>
            <ul class="footer-links">
              <li><router-link to="/about/profil">{{ $t("Nav.gywm_gsjj") }}</router-link></li>
              <li><router-link to="/about/culture">{{ $t("Nav.gywm_qywh") }}</router-link></li>
              <li><router-link to="/about/responsibility">{{ $t("Nav.gywm_shzr") }}</router-link></li>
            </ul>
          </div>

          <div class="footer-section">
            <h4 class="footer-title">{{ $t("Nav.cpyfw") }}</h4>
            <ul class="footer-links">
              <li><router-link to="/services">{{ $t("Nav.cpyfw") }}</router-link></li>
<!--              <li><router-link to="/prduct/jishuchubei">{{ $t("Nav.cpyfw_jscb") }}</router-link></li>-->
              <li><router-link to="/technology/zizhirenzheng">{{ $t("Nav.cpyfw_zzrz") }}</router-link></li>
            </ul>
          </div>
          <!-- 二维码 -->
<!--          <div class="footer-section footer-qr" >-->
<!--            <h4 class="footer-title">{{ $t("Nav.wxgxh") }}</h4>-->
<!--            <div class="qr-grid">-->
<!--              <div class="qr-item">-->
<!--                <span class="qr-label">{{ $t("Nav.wx_jljt") }}</span>-->
<!--                <el-image :src="require('@/assets/img/wx_jljt.jpg')" class="qr-image" />-->
<!--              </div>-->
<!--              <div class="qr-item">-->
<!--                <span class="qr-label">{{ $t("Nav.wx_cdjl") }}</span>-->
<!--                <el-image :src="require('@/assets/img/wx_cdjl.png')" class="qr-image" />-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>

        <!-- 版权信息 -->
        <div class="footer-bottom">
          <div class="footer-divider"></div>
          <div class="footer-copyright">
            <span>{{ $t("home.bqsy") }}</span>
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="beian-link">冀ICP备2026010745号</a>
            <span>{{ $t("home.jszc") }}</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from "vue"
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"
import { useStore } from 'vuex'

const store = useStore()
const { locale } = useI18n()
const router = useRouter()

// 语言切换
const lan = ref("EN")
const lanNow = computed(() => locale.value)

function changeLan() {
  if (lan.value === "EN") {
    locale.value = 'en'
    lan.value = "中"
  } else {
    locale.value = 'zh'
    lan.value = "EN"
  }
}

// 导航处理
function handleSelect(keyPath) {
  store.state.keyPath = keyPath
}

const defaultActive = computed(() => {
  const path = router.currentRoute.value.path
  if (store.state.keyPath && store.state.keyPath !== '/') {
    sessionStorage.setItem('keyPath2', store.state.keyPath)
  }
  return path || '/'
})

// 滚动效果
const isScrolled = ref(false)
function handleScroll() {
  isScrolled.value = window.scrollY > 20
}

// 移动端菜单
const mobileMenuOpen = ref(false)
function toggleMobileMenu() {
  mobileMenuOpen.value = !mobileMenuOpen.value
  document.body.style.overflow = mobileMenuOpen.value ? 'hidden' : ''
}

function closeMobileMenu() {
  mobileMenuOpen.value = false
  document.body.style.overflow = ''
}

onMounted(() => {
  store.state.keyPath = sessionStorage.getItem('keyPath2') || '/'
  window.addEventListener('scroll', handleScroll, { passive: true })
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style>
/* 导入设计系统 */
@import url('./assets/style/design-system.css');

/* ========================================
   军工级应用容器
   ======================================== */
.military-tech-app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: var(--font-body);
  background-color: var(--gray-100);
}

/* ========================================
   军工级头部导航
   ======================================== */
.military-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: var(--header-height-mobile);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid transparent;
  transition: all var(--transition-tech);
}

.military-header.scrolled {
  background: rgba(255, 255, 255, 0.98);
  border-bottom-color: var(--border-light);
  box-shadow: var(--shadow-sm);
}

@media (min-width: 1024px) {
  .military-header {
    height: var(--header-height);
  }
}

.header-container {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 var(--space-2);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: var(--space-2);
}

@media (min-width: 1024px) {
  .header-container {
    padding: 0 var(--space-4);
    gap: var(--space-2);
  }
}

@media (min-width: 1280px) {
  .header-container {
    padding: 0 var(--space-6);
    gap: var(--space-4);
  }
}

@media (min-width: 768px) {
  .header-container {
    padding: 0 var(--space-6);
  }
}

@media (min-width: 1024px) {
  .header-container {
    padding: 0 var(--space-8);
  }
}

/* Logo区域 */
.logo-section {
  display: flex;
  align-items: center;
  margin-bottom: -20px;
  /* padding: 20px; */
}

.logo-link {
  display: block;
  height: 32px;
}

.logo-image {
  height: 32px;
  width: auto;
}

@media (min-width: 1024px) {
  .logo-link {
    height: 36px;
  }

  .logo-image {
    height: 36px;
  }
}

/* ========================================
   桌面端导航
   ======================================== */
.desktop-nav {
  display: none;
  align-items: center;
  gap: var(--space-1);
  margin-left: auto;
}

@media (min-width: 1024px) {
  .desktop-nav {
    display: flex;
  }
}

@media (min-width: 1280px) {
  .desktop-nav {
    gap: var(--space-2);
  }
}

/* 军工级菜单样式 */
.military-menu {
  border-bottom: none !important;
  background: transparent !important;
}

.military-menu .el-menu-item,
.military-menu .el-sub-menu__title {
  font-size: var(--text-base);
  font-weight: var(--font-medium);
  letter-spacing: 0.02em;
  height: var(--header-height) !important;
  line-height: var(--header-height) !important;
  padding: 0 var(--space-1) !important;
  border-bottom: none !important;
  position: relative;
  transition: all var(--transition-base);
}

@media (min-width: 1200px) {
  .military-menu .el-menu-item,
  .military-menu .el-sub-menu__title {
    padding: 0 var(--space-2) !important;
  }
}

@media (min-width: 1360px) {
  .military-menu .el-menu-item,
  .military-menu .el-sub-menu__title {
    padding: 0 var(--space-3) !important;
  }
}

@media (min-width: 1440px) {
  .military-menu .el-menu-item,
  .military-menu .el-sub-menu__title {
    padding: 0 var(--space-4) !important;
  }
}

.military-menu .el-menu-item::after,
.military-menu .el-sub-menu__title::after {
  content: '';
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--primary-dark), var(--accent-gold));
  transition: width var(--transition-base);
}

.military-menu .el-menu-item:hover::after,
.military-menu .el-sub-menu__title:hover::after,
.military-menu .el-menu-item.is-active::after {
  width: 60%;
}
.el-menu--horizontal>.el-sub-menu.is-active div{
  color: var(--accent-gold) !important;
  font-weight: var(--font-semibold) !important;
  background: linear-gradient(180deg,
  rgba(212, 175, 55, 0) 0%,
  rgba(212, 175, 55, 0.1) 30%,
  rgba(212, 175, 55, 0.18) 100%
  ) !important;
  border-radius: var(--radius-md) var(--radius-md) 0 0 !important;
}
.el-menu--horizontal .el-menu-item.is-active {
  color: var(--accent-gold) !important;
  font-weight: var(--font-semibold) !important;
  background: linear-gradient(180deg,
    rgba(212, 175, 55, 0) 0%,
    rgba(212, 175, 55, 0.1) 30%,
    rgba(212, 175, 55, 0.18) 100%
  ) !important;
  border-radius: var(--radius-md) var(--radius-md) 0 0 !important;
}

.military-menu .el-menu-item:focus-visible,
.military-menu .el-sub-menu__title:focus-visible {
  outline: 2px solid var(--accent-gold);
  outline-offset: -2px;
  border-radius: var(--radius-sm);
}

/* 隐藏子菜单箭头 */
.military-menu .el-sub-menu__icon-arrow {
  display: none !important;
}

/* 子菜单样式 */
.military-submenu {
  border-radius: var(--radius-lg) !important;
  overflow: hidden;
  box-shadow: var(--shadow-xl) !important;
  border: var(--border-card) !important;
}

.military-submenu .el-menu {
  padding: var(--space-2) 0 !important;
}

.military-submenu .el-menu-item {
  height: 44px !important;
  line-height: 44px !important;
  font-size: var(--text-sm) !important;
  padding: 0 var(--space-6) !important;
  min-width: 180px;
}

.military-submenu .el-menu-item:hover {
  background: linear-gradient(90deg, rgba(16, 37, 66, 0.05), transparent) !important;
  color: var(--primary-dark) !important;
}

/* 语言切换按钮 */
.lang-switch {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) var(--space-4);
  background: transparent;
  border: 1px solid var(--border-medium);
  border-radius: var(--radius-md);
  font-size: var(--text-xs);
  font-weight: var(--font-semibold);
  color: var(--primary-dark);
  cursor: pointer;
  transition: all var(--transition-base);
}

.lang-switch:hover {
  background: var(--primary-dark);
  color: var(--white);
  border-color: var(--primary-dark);
}

.lang-text {
  min-width: 20px;
  text-align: center;
}

.lang-divider {
  width: 1px;
  height: 12px;
  background: currentColor;
  opacity: 0.3;
}

/* ========================================
   移动端菜单按钮
   ======================================== */
.mobile-menu-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  width: 44px;
  height: 44px;
  padding: 10px;
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  z-index: 1001;
  transition: background-color var(--transition-fast);
}

.mobile-menu-btn:hover {
  background-color: rgba(16, 37, 66, 0.05);
}

.mobile-menu-btn:focus-visible {
  outline: 2px solid var(--primary-dark);
  outline-offset: 2px;
}

@media (min-width: 1024px) {
  .mobile-menu-btn {
    display: none;
  }
}

.menu-line {
  display: block;
  width: 100%;
  height: 2px;
  background: var(--primary-dark);
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.menu-line.active:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.menu-line.active:nth-child(2) {
  opacity: 0;
}

.menu-line.active:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ========================================
   移动端抽屉导航
   ======================================== */
.mobile-drawer {
  position: fixed;
  inset: 0;
  z-index: 999;
  background: rgba(16, 37, 66, 0.5);
  backdrop-filter: blur(4px);
}

.mobile-nav {
  position: absolute;
  top: 0;
  right: 0;
  width: 85%;
  max-width: 360px;
  height: 100%;
  background: var(--white);
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-xl);
}

.mobile-nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4) var(--space-5);
  border-bottom: 1px solid var(--gray-200);
}

.mobile-logo {
  height: 36px;
  width: auto;
}

.close-btn {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: var(--radius-md);
  font-size: 28px;
  color: var(--gray-600);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.close-btn:hover {
  color: var(--primary-dark);
  background-color: rgba(16, 37, 66, 0.05);
}

.close-btn:focus-visible {
  outline: 2px solid var(--primary-dark);
  outline-offset: 2px;
}

.mobile-menu-list {
  flex: 1;
  overflow-y: auto;
  padding: var(--space-4) 0;
}

.mobile-menu-item {
  display: block;
  padding: var(--space-4) var(--space-5);
  font-size: var(--text-base);
  font-weight: var(--font-medium);
  color: var(--primary-dark);
  text-decoration: none;
  border-left: 3px solid transparent;
  transition: all var(--transition-base);
  min-height: 44px;
  display: flex;
  align-items: center;
}

.mobile-menu-item:hover,
.mobile-menu-item.router-link-active {
  background: linear-gradient(90deg, rgba(16, 37, 66, 0.08), transparent);
  border-left-color: var(--accent-gold);
  color: var(--primary-dark);
}

.mobile-menu-item.router-link-active {
  font-weight: var(--font-semibold);
}

.mobile-submenu {
  border-bottom: 1px solid var(--gray-100);
}

.mobile-submenu-title {
  padding: var(--space-3) var(--space-5);
  font-size: var(--text-sm);
  font-weight: var(--font-semibold);
  color: var(--gray-500);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.mobile-submenu-item {
  display: flex;
  align-items: center;
  padding: var(--space-3) var(--space-5) var(--space-3) var(--space-8);
  font-size: var(--text-sm);
  color: var(--gray-700);
  text-decoration: none;
  transition: all var(--transition-base);
  min-height: 40px;
}

.mobile-submenu-item:hover,
.mobile-submenu-item.router-link-active {
  color: var(--primary-dark);
  background: linear-gradient(90deg, rgba(212, 175, 55, 0.1), transparent);
  border-left: 2px solid var(--accent-gold);
  margin-left: -2px;
}

.mobile-submenu-item.router-link-active {
  font-weight: var(--font-medium);
  color: var(--primary-dark);
}

.mobile-lang-switch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-4) var(--space-5);
  margin: var(--space-4);
  background: var(--gray-100);
  border: 1px solid var(--gray-200);
  border-radius: var(--radius-lg);
  font-size: var(--text-sm);
  color: var(--gray-700);
  cursor: pointer;
  transition: all var(--transition-base);
}

.mobile-lang-switch:hover {
  background: var(--primary-dark);
  color: var(--white);
  border-color: var(--primary-dark);
}

.lang-current {
  font-weight: var(--font-semibold);
  color: var(--primary-dark);
}

.mobile-lang-switch:hover .lang-current {
  color: var(--white);
}

/* 抽屉动画 */
.slide-drawer-enter-active,
.slide-drawer-leave-active {
  transition: opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-drawer-enter-from,
.slide-drawer-leave-to {
  opacity: 0;
}

.slide-drawer-enter-active .mobile-nav,
.slide-drawer-leave-active .mobile-nav {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-drawer-enter-from .mobile-nav,
.slide-drawer-leave-to .mobile-nav {
  transform: translateX(100%);
}

/* 减少动画偏好支持 */
@media (prefers-reduced-motion: reduce) {
  .slide-drawer-enter-active,
  .slide-drawer-leave-active,
  .slide-drawer-enter-active .mobile-nav,
  .slide-drawer-leave-active .mobile-nav {
    transition: none;
  }

  .mobile-menu-btn .menu-line,
  .close-btn,
  .mobile-menu-item,
  .mobile-submenu-item {
    transition: none;
  }
}

/* ========================================
   主内容区域
   ======================================== */
.main-content {
  flex: 1;
  margin-top: var(--header-height-mobile);
  min-height: calc(100vh - var(--header-height-mobile));
}

@media (min-width: 1024px) {
  .main-content {
    margin-top: var(--header-height);
    min-height: calc(100vh - var(--header-height));
  }
}

/* ========================================
   军工级页脚
   ======================================== */
.military-footer {
  background: linear-gradient(135deg, var(--primary-darker) 0%, var(--primary-dark) 50%, var(--primary-light) 100%);
  color: var(--silver-light);
  padding: var(--space-12) 0 var(--space-6);
  position: relative;
  overflow: hidden;
}

.military-footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg,
    var(--accent-gold) 0%,
    var(--silver) 50%,
    var(--accent-gold) 100%
  );
}

.footer-container {
  max-width: var(--max-width);
  margin: 0 auto;
  padding: 0 var(--space-4);
}

@media (min-width: 768px) {
  .footer-container {
    padding: 0 var(--space-6);
  }
}

@media (min-width: 1024px) {
  .footer-container {
    padding: 0 var(--space-8);
  }
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-8);
  margin-bottom: var(--space-8);
}

@media (min-width: 640px) {
  .footer-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (min-width: 1024px) {
  .footer-grid {
    grid-template-columns: 2fr 1fr 1fr;
    gap: var(--space-10);
  }
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-brand {
  grid-column: 1 / -1;
}

@media (min-width: 1024px) {
  .footer-brand {
    grid-column: auto;
  }
}

.footer-logo {
  height: 48px;
  width: auto;
  margin-bottom: var(--space-4);
  filter: brightness(0) invert(1);
}

.footer-company {
  font-family: var(--font-display);
  font-size: var(--text-lg);
  font-weight: var(--font-bold);
  color: var(--white);
  margin-bottom: var(--space-4);
  letter-spacing: 0.02em;
}

.footer-contact {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.footer-contact p {
  font-size: var(--text-sm);
  color: var(--silver);
  line-height: var(--leading-relaxed);
}

.contact-label {
  color: var(--silver-dark);
}

.footer-title {
  font-size: var(--text-sm);
  font-weight: var(--font-semibold);
  color: var(--white);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-bottom: var(--space-4);
  padding-bottom: var(--space-2);
  border-bottom: 1px solid rgba(192, 197, 206, 0.2);
}

.footer-links {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.footer-links a {
  font-size: var(--text-sm);
  color: var(--silver);
  text-decoration: none;
  transition: all var(--transition-base);
  display: inline-block;
  padding: 4px 0;
  border-radius: var(--radius-sm);
}

.footer-links a:hover,
.footer-links a:focus-visible {
  color: var(--accent-gold);
  transform: translateX(4px);
  outline: 2px solid var(--accent-gold);
  outline-offset: 2px;
}

/* 二维码区域 */
.footer-qr {
  grid-column: 1 / -1;
}

@media (min-width: 640px) {
  .footer-qr {
    grid-column: auto;
  }
}

.qr-grid {
  display: flex;
  gap: var(--space-6);
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-2);
}

.qr-label {
  font-size: var(--text-xs);
  color: var(--silver-dark);
  text-align: center;
}

.qr-image {
  width: 100px;
  height: 100px;
  border-radius: var(--radius-md);
  overflow: hidden;
  border: 2px solid rgba(192, 197, 206, 0.2);
}

@media (min-width: 1024px) {
  .qr-image {
    width: 120px;
    height: 120px;
  }
}

/* 底部版权 */
.footer-bottom {
  padding-top: var(--space-6);
}

.footer-divider {
  height: 1px;
  background: linear-gradient(90deg,
    transparent,
    rgba(192, 197, 206, 0.3) 20%,
    rgba(192, 197, 206, 0.3) 80%,
    transparent
  );
  margin-bottom: var(--space-6);
}

.footer-copyright {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  text-align: center;
  font-size: var(--text-xs);
  color: var(--silver-dark);
}

@media (min-width: 640px) {
  .footer-copyright {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
}

.beian-link {
  color: var(--silver-dark);
  transition: color 0.3s ease;
}

.beian-link:hover {
  color: var(--primary-blue);
}

/* ========================================
   全局链接样式覆盖
   ======================================== */
a {
  color: inherit;
  text-decoration: none;
}

/* Element Plus 样式覆盖 */
.el-menu--horizontal {
  border-bottom: none !important;
}

.el-menu--popup-container {
  background: transparent !important;
}
</style>
